import { Col, Row, Input, Form, Select, Avatar, Switch, Space, Table } from 'antd'
import styles from '../styles.module.scss'
import { useContext, useEffect, useState } from 'react'
import Context from '../../Context'
import find from 'lodash/find'
import BaseLayout from 'components/BaseLayout'
import { TbUser } from 'react-icons/tb'
import { UserInterface } from 'containers/Admin/Users/contextTypes'
// helpers
import get from 'lodash/get'
import map from 'lodash/map'
import filter from 'lodash/filter'
import flatMap from 'lodash/flatMap'
import isEmpty from 'lodash/isEmpty'

const { Option } = Select

const columns = [

  {
    title: 'Rol',
    width: 100,
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Descripción',
    dataIndex: 'description',
    key: '1',
    width: 150,
  }
];

const UpdateUserInfo: React.FC<{ form: any }> = ({ form }) => {
  const {
    states: { selectedUser, roles, type },
    queryHandler: { data }
  } = useContext(Context)
  const [selections, setSelections] = useState([])
  const user: UserInterface =
    find(data, ({ id }) => selectedUser === id) ?? {}

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelections(map(selectedRows, ({ role }) => role))
    },
  };

  useEffect(() => {
    if (!isEmpty(user?.roles)) {
      setSelections(user.roles)
    }
  }, [])

  useEffect(() => {
    form.setFieldValue('roles', selections)
  }, [selections])

  return (
    <BaseLayout className="updateUserCard">
      <div className={styles.updateUser}>
        <Row>
          <Col>
            <div className="modalChild">
              <h2>{type === 'updateUser' ? 'Actualizar información de usuario' : 'Crear nuevo usuario'}</h2>
              <Avatar
                className="img"
                icon={<TbUser style={{ fontSize: '6rem' }} />}
                style={{
                  display: 'flex',
                  width: '7rem',
                  height: '7rem',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#1E99E1'
                }}
              />
              <Form
                form={form}
                layout="vertical"
                style={{ width: 340 }}
                initialValues={{
                  firstname: user.firstname,
                  lastname: user.lastname,
                  username: user.username,
                  active: user.active,
                  roles: user.roles
                }}
              >
                <Space align="center">
                  <Form.Item
                    label="Nombre"
                    name="firstname"
                    rules={[
                      { required: true, message: 'Nombre es un campo requerido' }
                    ]}
                  >
                    <Input placeholder="Juan" />
                  </Form.Item>
                  <Form.Item
                    label="Apellido"
                    name="lastname"
                    rules={[
                      {
                        required: true,
                        message: 'Apellido es un campo requerido'
                      }
                    ]}
                  >
                    <Input placeholder="Perez" />
                  </Form.Item>
                </Space>
                <Form.Item
                  label="Email"
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: 'El Email es un campo requerido',
                      type: 'email',

                    }
                  ]}
                >
                  <Input type="email" placeholder="john.doe@ex.com" disabled={type === 'updateUser'} />
                </Form.Item>
                {
                  type === 'createUser' ? (
                    <>
                      <Form.Item
                        label="Contraseña"
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: 'La contraseña es un campo requerido'

                          }
                        ]}
                      >
                        <Input type="password" placeholder="Contraseña" />
                      </Form.Item>

                      <Form.Item
                        label="Contraseña"
                        name="password_confirm"
                        rules={[
                          {
                            required: true,
                            message: 'La contraseña coincidir'

                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (!value || getFieldValue('password') === value) {
                                return Promise.resolve();
                              }
                              return Promise.reject(new Error('La contraseña ingresada no coincide'));
                            },
                          }),
                        ]}
                      >
                        <Input type="password" placeholder="Contraseña" />
                      </Form.Item>
                    </>
                  ) : null
                }


                <span className="" style={{ marginBottom: 27, display: 'inline-block' }} title="Email">Roles</span>

                <Table columns={columns as any} dataSource={filter(roles, ({ status }) => status)} scroll={{ y: 115 }} pagination={false}
                  rowSelection={{
                    ...rowSelection, checkStrictly: true, selectedRowKeys: flatMap(roles, ({ role, id }) => {
                      if (!selections.includes(role)) return []

                      return id
                    })
                  }}
                />

              </Form>
            </div>
          </Col>
        </Row>
      </div>
    </BaseLayout>
  )
}

export default UpdateUserInfo
